import { VALTYPES } from '../../../../data/interfaces';
import { categoricalOrderOptions } from '../../helpers/categoricalSorters';
import { createConfigParamMultipleChoice, createConfigParamTypeDiscreteColorScheme } from '../../helpers/configParams';
import { TpChartManifest } from '../interfaces';
import { ColorLegendCategorical } from './ColorLegendCategorical';

export const manifestColorLegendCategorical: TpChartManifest = {
  id: 'ColorLegendCategorical',
  name: 'Categorical color legend',
  description: `Displays the distribution of a categorical property by showing the number of occurrences of each different state as slices.
  The states are displayed as different lines in a list. This plot is useful in case the states have very long (e.g. full sentences).
`,
  component: ColorLegendCategorical,
  canvasBased: false,
  groups: [{ groupId: 'cats', groupName: 'Categories' }],

  aspects: [
    {
      id: 'categories',
      name: 'Categories data',
      description: 'Property to show the states for.',
      groupId: 'cats',
      required: true,
      quality: 1,
      dataType: VALTYPES.CATEGORICAL,
    },
  ],
  configParams: [
    {
      id: 'categoriesSchemeCategorical',
      name: 'Color scheme',
      groupId: 'cats',
      paramType: createConfigParamTypeDiscreteColorScheme(),
    },
    {
      id: 'sortBy',
      name: 'Sort by',
      groupId: 'cats',
      description: 'How to sort the categorical values.',
      paramType: createConfigParamMultipleChoice(categoricalOrderOptions),
    },
  ],
  examples: [
    {
      id: 'catcolorlegend_1',
    },
  ],
};
